import angular from 'angular'
import Emitter from '../utils/emitter'

angular
  .module('ggs.gallery-vote-frame')
  .factory('reinstanceSignalEmitter', ReinstanceSignalEmitterProvider)

function ReinstanceSignalEmitterProvider() {
  return Emitter('reinstanceSignalEmitter')
}
